import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { SettingsConfirmTemplate } from 'components/Templates'

const InformationConfirm: FC = () => {
  return (
    <Layout title={'確認 | 店舗基本情報を編集'}>
      <SettingsConfirmTemplate page={'shop'} />
    </Layout>
  )
}

export default InformationConfirm
